import React from 'react';

import { View } from 'react-native';

import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import RecentOrderCardList from 'pages/menu/recent-items-page/recent-order-card-list';

import withMenuEmptyState from '../components/with-menu-empty-state';

const MenuRecentItemsComponent = () => {
  useRumPageView('menu-recents', 'Menu Recents Items');

  return (
    <View style={{ flex: 1 }} testID="menu-recents-page">
      <RecentOrderCardList />
    </View>
  );
};

export const MenuRecentItemsPage = withMenuEmptyState(MenuRecentItemsComponent);
